import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Users,
  ChevronRight,
  Layers,
  ListCollapse,
  
} from 'lucide-react';

const Sidebar = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(true);
  const [activeSubmenu, setActiveSubmenu] = useState('');
  const [isMobile, setIsMobile] = useState(false);

  const menuItems = [
    // { path: '/home', label: 'Dashboard', icon: Layers },
    // {
    //   path: '/Smart',
    //   label: 'Smart Document',
    //   icon: Package,
    //   submenu: ['Dropdown one', 'Dropdown two', 'Dropdown three']
    // },
    { path: '/smartdocument', label: 'Smart Document', icon: ListCollapse },
    // { path: '/inbox', label: 'Setting', icon: Users },
  ];

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 800); // 768px is typical tablet/mobile breakpoint
    };
    // Set initial value
    checkIfMobile();
    // Add event listener
    window.addEventListener('resize', checkIfMobile);
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const toggleSubmenu = (path) => {
    if (activeSubmenu === path) {
      setActiveSubmenu('');
    } else {
      setActiveSubmenu(path);
    }
  };

  return (

    <>
      {/* Mobile overlay background */}
      {
        isMobile && isMobileMenuOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-50"
            
          >
            <div className={`h-screen bg-[#134A9F] border-r fixed transition-all duration-300 z-30 ${isMobile
                ? `top-0 ${isMobileMenuOpen ? 'left-0 w-64' : '-left-64 w-64'}`
                : ``
              }`}>
                <div className='w-full flex flex-row justify-between text-[#ffff] p-2'>
                <h1 className='text-[24px]'>Correspondence</h1>
                <p className='mr-2' onClick={() => setIsMobileMenuOpen(false)}>X</p>
                </div>
                
              {menuItems.map((item) => (
                <ul className='flex flex-col mt-2 ml-2' key={item.path}>
                  <Link to={item.path}>
                    <span className="ml-3 text-[#ffff]">{item.label}</span>
                  </Link>
                </ul>
              ))}
              </div>
            </div>
        )
      }


      <div className={`hidden lg:block h-screen bg-white border-r fixed transition-all duration-300 mt-16 ${isOpen ? 'w-12' : 'w-12'}`}>

        {/* Navigation Menu */}
        <nav className={`mt-1 ${isOpen ? 'w-12' : 'w-12'}`}>
          <ul className="space-y-1 ">
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`w-full flex items-center px-3 py-2 group cursor-pointer
                  ${location.pathname === item.path ? 'bg-blue-50 text-[#4D77ff] border-r-2 border-[#4D77ff]' : 'text-gray-600 hover:bg-gray-50'}`}
                  onClick={() => item.submenu && toggleSubmenu(item.path)}
                >
                  <item.icon className="h-5 w-5 shrink-0" />

                  {isOpen && (
                    <>
                      {/* <span className="ml-3">{item.label}</span> */}
                      {item.submenu && (
                        <ChevronRight
                          className={`ml-auto h-4 w-4 transition-transform duration-200
                          ${activeSubmenu === item.path ? 'rotate-90' : ''}`}
                        />
                      )}
                    </>
                  )}
                </Link>

                {/* Submenu */}
                {isOpen && item.submenu && activeSubmenu === item.path && (
                  <ul className="pl-11 mt-1 space-y-1">
                    {item.submenu.map((subItem) => (
                      <li key={subItem}>
                        <Link
                          to={`${item.path}/${subItem.toLowerCase().replace(' ', '-')}`}
                          className="block py-2 px-2 text-sm text-gray-600 hover:text-blue-600 rounded-lg"
                        >
                          {subItem}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>

  );
};

export default Sidebar;